import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Proveedor } from "@/shared/types/proveedor";

export interface ProveedorEditRequest {
    nombre: string,
    numDocumento: string,
    email?: string,
    telefono?: string,
    direccion?: string,
}

export async function editProveedor(id: string, request: ProveedorEditRequest): Promise<Proveedor> {
    await sleep(1000);
    const response = await api.put("proveedores/" + id, request);
    return response.data;
}

export function useEditProveedorMutation(id: string, mutationConfig: MutationConfig<Proveedor, ProveedorEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: ProveedorEditRequest) => await editProveedor(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["proveedores"] });
        },
    })
}

export interface EditProveedorMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Proveedor, ProveedorEditRequest>,
    children?:(mutationResult:MutationResult<Proveedor, ProveedorEditRequest>)=>ReactNode
}

export function EditProveedorMutation({
    id,
    children,
    mutationConfig
}:EditProveedorMutationProps){
    const mutationResult = useEditProveedorMutation(id, mutationConfig);
    return children&&children(mutationResult)
}